/**
 * DownloadAppPage.tsx - Public #/download-app page, the target of the desktop QR
 * code. Phones are sent straight to their store; everyone else (and a phone whose
 * redirect is blocked) sees both badges. No auth, no circle bootstrap.
 */

import { useEffect } from 'react'
import { Heading, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { StoreBadgeRow } from '@/ui/components/AppInstall'
import { currentPlatform, installAction } from '@/utilities/appInstall'

export const DownloadAppPage: React.FC = () => {
    const { t, i18n } = useTranslation()

    useEffect(() => {
        const action = installAction(currentPlatform())
        // replace(), so Back from the store doesn't bounce the visitor into it again.
        if (action.kind === 'navigate') window.location.replace(action.url)
    }, [])

    return (
        <VStack dir={i18n.dir()} justify="center" align="center" minHeight="100dvh" gap="4" paddingX="4" background="white" textAlign="center">
            <Heading size="lg">{t('app_install_title') || 'Get the Mushtarek app'}</Heading>
            <Text fontSize="sm" color="fg.muted">{t('app_install_choose_store') || 'Choose your app store.'}</Text>
            <StoreBadgeRow />
        </VStack>
    )
}

export default DownloadAppPage
